<template>
    <div class="filter-collection">
        <hr>

        <div class="filter-collection__header">
            <div><p><strong>Filter by:</strong></p></div>
            <FormBtn
                variant="cms"
                @click="clear"
                class="filter-collection__header__clear"
                v-if="showClear"
            >
                Show all
            </FormBtn>
        </div>

        <GridContainer v-if="Object.keys(filterOn).length">
            <GridColumn
                v-for="filter in Object.keys(filterOn).filter(filter => filter !== 'other')"
                :key="filter"
                class="col-span-12 lg:col-span-4"
            >
                <FilterSelect
                    :relation="filter"
                    :method="filterOn[filter].method || null"
                    v-model="innerFilters[filterOn[filter].foreignKey]"
                    @change="update"
                />
            </GridColumn>

            <GridColumn
                v-for="otherFilterType in (filterOn['other'] || [])"
                :key="otherFilterType"
                class="col-span-12 lg:col-span-4"
            >
                <AdminSelect
                    :options="getOtherFilterOptions(otherFilterType)"
                    v-model="innerFilters[otherFilterType]"
                    @change="update"
                    class="resource-input"
                />
            </GridColumn>
        </GridContainer>

        <div class="filter-collection__search">
            <FormInput
                v-model="innerSearchString"
                placeholder="Search"
                class="mb-10"
                @input="update"
            />
        </div>

        <hr>
    </div>
</template>

<script>
import {inject} from "vue";
import Kernel from "@oilstone/kernel";

export default {
    setup() {
        const type = inject('type');
        const settings = Kernel.resolve('resourceRegistry').find(type);

        return {
            filterOn: settings.config.filterOn || {},
        }
    },

    props: ['searchString', 'filters'],

    data() {
        return {
            innerSearchString: this.searchString,
            innerFilters: this.filters,
        }
    },

    computed: {
        showClear() {
            return !!this.innerSearchString || Object.keys(this.innerFilters).some(filter => this.innerFilters[filter]);
        }
    },

    methods: {
        clear() {
            this.innerSearchString = '';

            for (const filterKey in this.innerFilters) {
                this.innerFilters[filterKey] = '';
            }

            this.update();
        },

        update() {
            this.$emit('update:searchString', this.innerSearchString);
            this.$emit('update:filters', this.innerFilters);
        },

        getOtherFilterOptions(filter) {
            switch (filter) {
                case 'publishYear':
                    return [{label: ' - Year', value: ''}].concat([...Array((2030 - 1950) + 1).keys()].map(x => x + 1950).reverse().map(year => {
                        return {
                            label: year,
                            value: year
                        };
                    }));

                case 'unpublishedChanges':
                    return [
                        {
                            label: ' - Unpublished changes',
                            value: '',
                        },
                        {
                            label: 'Yes',
                            value: '1',
                        },
                        {
                            label: 'No',
                            value: '0',
                        },
                    ];

                case 'isPublished':
                    return [
                        {
                            label: ' - Status',
                            value: '',
                        },
                        {
                            label: 'Published',
                            value: '1',
                        },
                        {
                            label: 'Draft',
                            value: '0',
                        },
                    ];
            }
        },
    },

    watch: {
        searchString() {
            this.innerSearchString = this.searchString;
        },

        filters() {
            this.innerFilters = this.filters;
        },
    }
}
</script>

<style>
.filter-collection {
    &__header {
        @apply flex justify-between mb-4;
    }
}
</style>
